import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams, ISearchResponse } from '@/types';
import { ICustomLeagueApiListResponse, ICustomLeagueUpdateParams, ICustomLeagueUpdateResponse } from '@/types/customLeaguePage';

export const customLeagueList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<ICustomLeagueApiListResponse>> => {
    return axios.get('/api/customLeague/list', { ...config, params });
};

export const customLeagueCreate = (params: ICustomLeagueUpdateParams): Promise<AxiosResponse<ICustomLeagueUpdateResponse>> => {
    return axios.post('/api/customLeague/create', params);
};

export const customLeagueDelete = (params: ICustomLeagueUpdateParams): Promise<AxiosResponse<ICustomLeagueUpdateResponse>> => {
    return axios.post('/api/customLeague/delete', params);
};

export const customLeagueUpdate = (params: ICustomLeagueUpdateParams): Promise<AxiosResponse<ICustomLeagueUpdateResponse>> => {
    return axios.post('/api/customLeague/update', params);
};

export const searchCustomLeagues = (query: string, sportId: number): Promise<AxiosResponse<ISearchResponse>> => {
    return axios.get('/api/customLeague/search', { params: { query, sport_id: sportId } });
};
